import $ from 'jquery';
/**
 * Globally required assets.
 */
import './css/main.scss';
import './css/scss/1-settings/_global-vars.scss';
import './css/scss/1-settings/_typography.scss';
import './css/scss/3-base/_global.scss';
import './css/scss/3-base/_lists.scss';
import './css/scss/3-base/_media.scss';
import './css/scss/3-base/_grid.scss';
import './css/scss/4-objects/_header.scss';
import './css/scss/4-objects/_branding.scss';
import './css/scss/4-objects/_footer.scss';
import './css/scss/4-objects/_breadcrumbs.scss';
import './css/scss/4-objects/_pagination.scss';
import './css/scss/4-objects/_gravity-forms.scss';
import './css/scss/4-objects/_matador-application.scss';
import './views/library/components/cta/cta.scss';
import './img/favicon/favicon.ico';
import './img/favicon/android-chrome-192x192.png';
import './img/favicon/android-chrome-256x256.png';
import './img/favicon/apple-touch-icon.png';
import './img/favicon/favicon-16x16.png';
import './img/favicon/site.webmanifest';
import './img/favicon/favicon-32x32.png';
import './img/favicon/mstile-150x150.png';
import './img/favicon/safari-pinned-tab.svg';
import './img/favicon/browserconfig.xml';
/**
 * Globally imported scripts
 */
import './js/menu.js';
import './js/svg-inline.js';

/**
 * Recommended - use 'import' above to include global JS
 * However, you can also add items below if needed
 */

// ( () => {
//     $( document ).ready( function () {
//     	// Global items here
//     } );
// } )();



// WEBPACK FOOTER //
// ./resources/main.js